import { throttle } from 'lodash';

export const setUpFigureCarousel = () => {
  const carousels = [
    ...document.querySelectorAll('.js-figure-carousel, .js-related-carousel'),
  ];
  carousels.forEach((carousel) => {
    const slidesContainer = carousel.querySelector('.js-slides-container');
    if (!slidesContainer) return;

    const slides = slidesContainer.children;
    if (!slides) return;

    const prevButtonContainer = carousel.querySelector(
      '.js-prev-button-container',
    );
    const nextButtonContainer = carousel.querySelector(
      '.js-next-button-container',
    );
    if (!prevButtonContainer || !nextButtonContainer) return;

    const prevButton = prevButtonContainer.querySelector('button');
    const nextButton = nextButtonContainer.querySelector('button');
    if (!prevButton || !nextButton) return;

    let currPrimarySlideIndex = 0;

    function scrollToPrimaryPosition(element: Element): void {
      if (!element) return;

      (element as HTMLDivElement).scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start',
      });

      let lastPosition: number;
      let unchangedFramesCount: number;

      function checkAnimationComplete() {
        const newPosition = element.getBoundingClientRect().right;

        if (newPosition === lastPosition) {
          // after two unchanged frames, we can be sure the animation
          // is complete. this needs to be checked so we can accurately
          // decide which carousel nav buttons to display
          if (unchangedFramesCount++ > 2) {
            handleDisplayNavButtons();
            return;
          }
        } else {
          unchangedFramesCount = 0;
          lastPosition = newPosition;
        }

        requestAnimationFrame(checkAnimationComplete);
      }

      requestAnimationFrame(checkAnimationComplete);
    }

    function handleDisplayNavButtons() {
      // small screen widths use horizontal scrolling to navigate carousel
      const viewportWidth = window.innerWidth;
      if (viewportWidth < 568) {
        (prevButtonContainer as HTMLButtonElement).style.display = 'none';
        (nextButtonContainer as HTMLButtonElement).style.display = 'none';
        return;
      }

      if (currPrimarySlideIndex === 0) {
        (prevButtonContainer as HTMLButtonElement).style.display = 'none';
      } else {
        (prevButtonContainer as HTMLButtonElement).style.display = 'flex';
      }

      // check if the last slide is fully visible within the slides container
      const lastSlide = slides[slides.length - 1] as HTMLDivElement;
      const lastSlideRect = lastSlide.getBoundingClientRect();
      const containerRect = (
        slidesContainer as HTMLDivElement
      ).getBoundingClientRect();

      if (lastSlideRect.right > containerRect.right) {
        (nextButtonContainer as HTMLButtonElement).style.display = 'flex';
      } else {
        (nextButtonContainer as HTMLButtonElement).style.display = 'none';
      }
    }

    function handlePrevButtonClick() {
      if (currPrimarySlideIndex > 0) {
        currPrimarySlideIndex--;
        scrollToPrimaryPosition(slides[currPrimarySlideIndex]);
      }
    }

    function handleNextButtonClick() {
      if (currPrimarySlideIndex < slides.length - 1) {
        currPrimarySlideIndex++;
        scrollToPrimaryPosition(slides[currPrimarySlideIndex]);
      }
    }

    handleDisplayNavButtons();
    prevButton.addEventListener('click', handlePrevButtonClick);
    nextButton.addEventListener('click', handleNextButtonClick);

    const throttledHandleDisplayNavButtons = throttle(
      handleDisplayNavButtons,
      250,
    );
    window.addEventListener('resize', throttledHandleDisplayNavButtons);
  });
};
